// extracted by mini-css-extract-plugin
export var askAiIcon = "_ny-j";
export var category = "_ny-9";
export var categoryHeader = "_ny-e";
export var container = "_ny-0";
export var group = "_ny-a";
export var groupItems = "_ny-f";
export var groupSeparator = "_ny-k";
export var loading = "_ny-1";
export var noResults = "_ny-3";
export var placeholder = "_ny-2";
export var resultContent = "_ny-5";
export var resultIcon = "_ny-c";
export var resultItem = "_ny-g";
export var resultMeta = "_ny-8";
export var resultSubtitle = "_ny-7";
export var resultSuffix = "_ny-i";
export var resultTitle = "_ny-6";
export var resultsList = "_ny-4";
export var searchGroup = "_ny-d";
export var selected = "_ny-h";
export var subgroup = "_ny-b";